import * as React from 'react';
import { isComponentType, registerComponent, useMatchSmallViewport } from '@avensia/excite';
import ContentListEntry from './ContentListEntry';

export default registerComponent<Excite.Contentful.ContentListApiModel>(
  React.memo(props => {
    const isSmallViewport = useMatchSmallViewport();

    const filterEntries = React.useCallback(
      (displayConditions?: Excite.Contentful.ICFDisplayConditions) => {
        if (!displayConditions) {
          return true;
        }

        return false;
      },
      [isSmallViewport],
    );
    return (
      <>
        {(props.items || [])
          .filter(
            i =>
              i && (isComponentType<Excite.Contentful.ConditionalPlaceholder>(i) || filterEntries(i.displayConditions)),
          )
          .map((item, i: number) => (
            <ContentListEntry index={i} key={item.id + i} item={item} />
          ))}
      </>
    );
  }),
);
